import { takeEvery, put, call, select } from 'redux-saga/effects'

import { parse } from 'csv-string'
import { v1 as uuidv1 } from 'uuid'
// @ts-ignore
import * as helpers from 'helpers'
import { Map } from 'immutable'

// @ts-ignore
import { templateFileChange, addActivitiesFromFile } from '../actions'
// @ts-ignore
import { getActivitiesListOrdered } from '../selectors'
// @ts-ignore
import { getLevelsView, isViewLevelIsLibrary } from 'store/entities/protracks/levels/selectors'
// @ts-ignore
import { showWarning } from 'store/entities/toastr/utils'
// @ts-ignore
import { syncValidateForLibraryActivity, syncValidateForMicroActionActivity } from 'app/validators/activities/edit'
// @ts-ignore
import { getGalleryActivitiesImages } from 'store/entities/gallery/selectors'
import { IActivityBulkAdd, IFindImageExist } from 'store/entities/protracks/activities/sagas/interfaces'
// @ts-ignore
import { getViewProtrack } from 'store/entities/protracks/selectors'
// @ts-ignore
import { updateImageUsagePlaces } from 'store/entities/gallery/actions'
import { getActivityNameForUsagePlaces } from 'helpers/getActivityNameForUsagePlaces'

export function* parseCSVFile(file: File) {
  const text = yield call(helpers.promisedGetFileText, file)
  return parse(text, ',')
}

export function* updateUsagePlaces(
  images: Array<Map<string, any>>,
  activities: Array<{ image: string; name: string }>
) {
  for (const activity in activities) {
    const imageExist = images.find((image: Map<string, any>) => image.get('url') === activities[activity].image)
    if (imageExist !== undefined) {
      let usagePlaces = ''
      const viewProtrackName = (yield select(getViewProtrack)).get('name')
      usagePlaces += `______${viewProtrackName}___`
      // @ts-ignore
      usagePlaces = getActivityNameForUsagePlaces(activities[activity].name, usagePlaces)
      yield put(updateImageUsagePlaces(imageExist.get('url'), usagePlaces))
    }
  }
}

export function findImageExist({ images, activityImage }: IFindImageExist): string {
  const imageExist = images.find((image: Map<string, any>) => image.get('fileName') === activityImage)
  if (imageExist !== undefined) {
    return imageExist.get('url')
  }
  return activityImage
}

export function* convertCSVResultToActivitiesArray(dataFromCSV: Array<Array<string>>) {
  const currentLevel = yield select(getLevelsView)
  const isLibraryLevel = yield select(isViewLevelIsLibrary)
  const validate = isLibraryLevel ? syncValidateForLibraryActivity : syncValidateForMicroActionActivity
  const images = yield select(getGalleryActivitiesImages)
  return dataFromCSV.reduce((acc: Array<object>, activityArray: Array<string>, index: number) => {
    let image = activityArray[5]
    if (activityArray[5]) {
      image = findImageExist({ images, activityImage: activityArray[5] })
    }
    const activity = {
      id: `temp-${index}-${uuidv1()}`,
      name: activityArray[0],
      description: activityArray[1],
      proQuote: activityArray[2],
      proQuoteAuthor: activityArray[3],
      question: activityArray[4],
      image,
      categoryTag: { name: activityArray[6], id: activityArray[6] },
      level: currentLevel,
      fromFile: true,
      invalid: false,
      isImageLinkInvalid: false,
    }
    if (validate(activity)) {
      activity.invalid = true
    }
    if (image === activityArray[5]) {
      activity.isImageLinkInvalid = true
    }
    acc.push(activity)
    return acc
  }, [])
}

export function* activityBulkAdd({ payload }: IActivityBulkAdd) {
  try {
    const { data } = payload
    if (data && data.type === 'file' && data.files.length) {
      const file = data.files[0]
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (extension !== 'txt' && extension !== 'csv') {
        throw new Error('File must be csv or txt')
      }
      const dataFromCSV = yield parseCSVFile(file)
      const activitiesArray = yield convertCSVResultToActivitiesArray(dataFromCSV)
      const images = yield select(getGalleryActivitiesImages)
      yield updateUsagePlaces(images, activitiesArray)
      const currentActivities = yield select(getActivitiesListOrdered)
      const orderedActivities = [...currentActivities.toJS(), ...activitiesArray]
      yield put(addActivitiesFromFile(orderedActivities))
      data.value = ''
    }
  } catch (error) {
    showWarning({ content: error })
  }
}

export default function* bulkAddActivitiesSaga() {
  yield takeEvery(templateFileChange.toString(), activityBulkAdd)
}
